export default __webpack_public_path__ + "static/media/placeholder.3aa1eef5.jpeg";